/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryBase {
    getFixupPrototypeFunction() { return InventorySummaryBase.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryBase>): InventorySummaryBase {
        let obj = Object.assign(new InventorySummaryBase(), model);
        InventorySummaryBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryBase>): InventorySummaryBase {
        if (!model) return null;
        return InventorySummaryBase.newInstance(<InventorySummaryBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryBase) {
        if (!obj) return;

        models.InventorySummaryBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryBase): boolean {
        Object.setPrototypeOf(obj, InventorySummaryBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Resource or category or Resource type
     */
    name: string;

}
